module.exports = __webpack_public_path__ + "img/Brandstätter Lukas.jpg";